import $ from 'jquery'
import 'hesehus-js-parallax'

$('[data-parallaxbehaviour]').hParallax({
	$scrollTarget: $('.wrapper__view--main')
})
